/* @jsxImportSource react */

import * as React from 'react';
import { cn } from '../../../utils/cn/cn';

export interface PriceValueProps extends React.HTMLAttributes<HTMLSpanElement> {
  // This is used as a workaround until EDS3 has a correct size variant for the product cards
  fixedTextClass?: string;
}

const PriceValue = ({
  children,
  fixedTextClass,
  className,
  'aria-label': srLabel,
  ...props
}: PriceValueProps) => (
  <>
    {srLabel && <span className="sr-only">{srLabel}</span>}
    <span
      className={cn(
        `price-value whitespace-nowrap ${fixedTextClass} inline-flex grow-0 items-center justify-start font-bold [grid-area:c]`,
        className,
      )}
      {...props}
    >
      {children}
    </span>
  </>
);

PriceValue.displayName = 'PriceValue';

export { PriceValue };
